export const CONTENT_LANGUAGE_ENGLISH = 'ENGLISH'
export const CONTENT_LANGUAGE_FRENCH = 'FRENCH'

export const LOG_LEVEL_INFORMATION = 'Information'
export const LOG_LEVEL_WARNING = 'Warning'
export const LOG_LEVEL_ERROR = 'Error'
export const LOG_LEVEL_CRITICAL = 'Critical'

export const NOTIFICATION_TYPE_INFO = 'info'
export const NOTIFICATION_TYPE_WARNING = 'warning '
export const NOTIFICATION_TYPE_ERROR = 'error'
export const NOTIFICATION_TYPE_SUCCESS = 'success'

export const USER_TYPE_ANONYME = 'ANONYME'
export const USER_TYPE_ADMIN = 'SYSTEM_ADMIN'
export const USER_TYPE_USER = 'USER'
